import { Vue } from "vue-property-decorator";

const GroupWrapperComponent = Vue.extend({
  render(h){
    return h('div', {class: "flex w-full"}, this.slotFromParent({group: this.group}));
  },
  props: ['group', 'slotFromParent'],
  name: "GroupWrapper",
});

const ItemWrapperComponent = Vue.extend({
  render(h){
    return h('div', {class: "flex w-full"}, this.slotFromParent({item: this.item}));
  },
  props: ['item', 'slotFromParent'],
  name: "ItemWrapper",
});

const slotWrapperElement = (slot: any, value: any, type: string) => {
  const wrapper = type === "item"
    ? new ItemWrapperComponent({
      propsData: {
        slotFromParent: slot,
        item: value,
      }
    })
    : new GroupWrapperComponent({
      propsData: {
        slotFromParent: slot,
        group: value,
      }
    });
  return wrapper.$mount().$el;
}
export default slotWrapperElement;